import React from 'react';
import { createStyles, makeStyles } from '@material-ui/styles';
import { Button, Theme } from '@material-ui/core';
import { ButtonProps } from '@material-ui/core/Button';

export type Props = ButtonProps & {
  overlay?: boolean;
  styleButton?: 'orange' | 'default';
};

const useStyles = makeStyles(({ palette }: Theme) => createStyles({
  root: {
    '&:hover': {
      background: palette.buttonAction.overlay,
      borderRadius: 'inherit',
    },
    display: 'flex',
    alignItems: 'inherit',
    justifyContent: 'inherit',
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    borderRadius: 'inherit',
  },
  label: {
    borderRadius: 'inherit',
    fontFamily: 'Montserrat',
    fontSize: 16,
    padding: '6px 8px',
  },
  button: {
    padding: 0,
  },
  orangeRoot: {
    minWidth: 'unset',
    height: 40,
    padding: '4px 4px',
    color: palette.buttonAction.color,
    background: palette.buttonAction.background,
    '&:hover': {
      backgroundColor: palette.buttonAction.background,
    },
  },
}), { name: 'Button' });

const ButtonUI = React.forwardRef<HTMLButtonElement, Props>(({
  children,
  overlay = true,
  styleButton = 'default',
  classes,
  ...props
}: Props, ref) => {
  const mainClasses = useStyles();

  return (
    <Button
      classes={{
        root: styleButton === 'default' ? mainClasses.button : mainClasses.orangeRoot,
        label: mainClasses.label,
        ...classes,
      }}
      style={{ textTransform: 'unset' }}
      ref={ref}
      {...props}
    >
      {
        overlay
        && <span className={mainClasses.root} />
      }
      {children}
    </Button>
  );
});

export default ButtonUI;
